import { render } from "./PointNotation.vue?vue&type=template&id=22d63eee&scoped=true&ts=true"
import script from "./PointNotation.vue?vue&type=script&lang=ts"
export * from "./PointNotation.vue?vue&type=script&lang=ts"

import "./PointNotation.vue?vue&type=style&index=0&id=22d63eee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d63eee"]])

export default __exports__